import { render, staticRenderFns } from "./YardTable.vue?vue&type=template&id=35957662&"
import script from "./YardTable.vue?vue&type=script&lang=js&"
export * from "./YardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports